export default __webpack_public_path__ + "static/media/i_bus-noti-running_active.04c8e514.svg";